import React, { useRef, useState } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

// Format date helper
const formatDate = (date) => {
  const d = new Date(date);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
    2,
    "0",
  )}-${String(d.getDate()).padStart(2, "0")}`;
};

const PadaanPDFExporter = ({ padaans, skipPriceCheck = false }) => {
  const refs = useRef([]);
  const [progress, setProgress] = useState({
    show: false,
    current: 0,
    total: 0,
  });

  const getProductDetails = (order) => {
    if (skipPriceCheck) {
      return order?.new_order?.product_details || [];
    }
    return order?.product_details || [];
  };

  const calculatePriceNumber = (order) => {
    const products = getProductDetails(order);
    if (!products.length) return 0;

    return products.reduce((sum, product) => {
      return sum + (product.quantity * product.itemPrice || 0);
    }, 0);
  };

  // Зөвхөн status === 3 байгаа падаануудаа шүүнэ
  // const resolvedPadaans = padaans.filter(
  //   (p) => p.status === 3 && calculatePriceNumber(p) > 0,
  // );

  const resolvedPadaans = padaans.filter(
    (p) => p.status === 3 && (skipPriceCheck || calculatePriceNumber(p) > 0),
  );

  // PDF export function
  const exportImagesToPDF = async () => {
    console.log(resolvedPadaans);
    if (resolvedPadaans.length === 0) {
      alert("Шийдэгдсэн падаан алга!");
      return;
    }

    setProgress({ show: true, current: 0, total: resolvedPadaans.length });
    const pdf = new jsPDF({
      orientation: "p",
      unit: "mm",
      format: "a4",
      compress: true, // ⭐
    });

    for (let i = 0; i < resolvedPadaans.length; i++) {
      setProgress((pr) => ({ ...pr, current: i + 1 }));
      const node = refs.current[i];
      if (node) {
        const canvas = await html2canvas(node, { scale: 1.2, useCORS: true });
        const imgData = canvas.toDataURL("image/jpeg", 0.7);
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pageWidth - 30;
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

        if (i !== 0) pdf.addPage();
        pdf.addImage(
          imgData,
          "PNG",
          15,
          10,
          pdfWidth,
          pdfHeight > pageHeight ? pageHeight - 20 : pdfHeight,
        );
      }
    }
    setProgress({ show: false, current: 0, total: 0 });
    pdf.save(`padaan-list-resolved-${formatDate(new Date())}.pdf`);
  };

  return (
    <div>
      <button
        className="bg-red-500 text-white px-4 py-2 rounded mb-2 lg:mb-6 ml-0 lg:ml-4 hover:bg-red-600 transition duration-300 ease-in-out transform hover:scale-105"
        onClick={exportImagesToPDF}
      >
        Падаан PDF болгох
      </button>

      {/* Явц харуулах */}
      {progress.show && (
        <div
          style={{
            position: "fixed",
            top: "30%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 9999,
            background: "#fff",
            border: "1px solid #f3f3f3",
            boxShadow: "0 2px 16px #0002",
            padding: 32,
            borderRadius: 16,
            minWidth: 320,
            textAlign: "center",
          }}
        >
          <div style={{ fontSize: 22, marginBottom: 16 }}>
            Түр хүлээнэ үү...
          </div>
          <div style={{ fontSize: 16, marginBottom: 8 }}>
            {progress.total > 0 &&
              `${progress.current} / ${progress.total} падааныг боловсруулж байна...`}
          </div>
          <div
            style={{
              width: "100%",
              height: 14,
              background: "#eee",
              borderRadius: 6,
              overflow: "hidden",
              marginBottom: 8,
            }}
          >
            <div
              style={{
                width: `${(progress.current / progress.total) * 100}%`,
                height: "100%",
                background: "#ef4444",
                transition: "width 0.2s",
              }}
            />
          </div>
          <div style={{ color: "#666", fontSize: 14 }}>
            Энэ цонхыг хаахгүй байхыг зөвлөж байна.
          </div>
        </div>
      )}

      {/* Зөвхөн шийдэгдсэн падаануудыг нууж render хийнэ */}
      <div
        style={{
          position: "absolute",
          left: "-99999px",
          top: 0,
          width: "900px", // Бодит хэмжээгээ бичнэ
          height: "auto", // эсвэл өөрийн container өндөр
          overflow: "hidden",
          zIndex: -100,
          pointerEvents: "none",
        }}
      >
        {resolvedPadaans.map((data, idx) => (
          <div key={data.id} ref={(el) => (refs.current[idx] = el)}>
            <div
              id="modal-content"
              className="bg-white shadow-xl rounded-lg p-6 w-full max-w-4xl border border-gray-200 relative"
              style={{ width: 800, margin: "0 auto" }}
            >
              <img src="/Logo.jpg" alt="logo" className="w-40 mb-2" />
              <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                <h2 className="text-xl font-bold mb-4">Засварын падаан</h2>
                <h2 className="text-xl font-bold mb-4">Падаан №: {data.id}</h2>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-2 text-sm mb-4">
                <p>
                  <strong>Салбар:</strong> {data.infoCUBranch.name}
                </p>
                <p>
                  <strong>Үүсгэсэн Огноо:</strong>{" "}
                  {new Date(data.createdDate).toLocaleString()}
                </p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-2 text-sm mb-4">
                <p>
                  <strong>Засварласан инженер:</strong>{" "}
                  {data?.fixed_user?.TCUSERNAME || ""}
                </p>
                <p>
                  <strong>Засварласан Огноо:</strong>{" "}
                  {new Date(data.fixedDate).toLocaleString()}
                </p>
              </div>
              <hr className="my-4 border-gray-200" />
              <table className="w-full border mb-6">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border px-4 py-2 text-left">Бараа</th>
                    <th className="border px-4 py-2 text-right">Тоо</th>
                    <th className="border px-4 py-2 text-right">Үнэ</th>
                  </tr>
                </thead>
                <tbody>
                  {getProductDetails(data).map((p, index) => (
                    <tr key={index}>
                      <td className="border px-4 py-2">{p.productName}</td>
                      <td className="border px-4 py-2 text-right">
                        {p.quantity}
                      </td>
                      <td className="border px-4 py-2 text-right">
                        {p.itemPrice.toLocaleString()}₮
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="flex justify-between items-center mb-6">
                <strong>Нийт үнэ:</strong>
                <span className="font-bold text-lg">
                  {parseFloat(data.totalPrice).toLocaleString()}₮
                </span>
              </div>
              <p className="mb-5">
                <strong>Хүлээн авсан хэрэглэгчийн утас:</strong>{" "}
                {data.receivedPhone}
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-2 text-sm mb-4">
                <p>
                  <strong>Хүлээн авсан хэрэглэгчийн нэр:</strong>{" "}
                  {data.receivedName}
                </p>
                <div className="relative mb-5">
                  <img
                    src="/kaccService.png"
                    alt="Засварласан хэрэглэгч"
                    className="absolute -top-10 left-40 w-40"
                  />
                  <p>
                    <strong>Засварласан инженер:</strong>{" "}
                    {data?.fixed_user?.TCUSERNAME || ""}
                  </p>
                </div>
              </div>
              {data.images.length > 0 && (
                <>
                  <div className="flex justify-between items-center mb-4">
                    <h3 className="font-semibold">Гарын үсэг: </h3>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                    {data.images.map((image, index) => (
                      <img
                        key={index}
                        src={`https://api.cu.kacc.mn${image.image}`}
                        className="w-full h-48 object-cover cursor-pointer"
                        alt={`Attachment ${index + 1}`}
                      />
                    ))}
                  </div>
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PadaanPDFExporter;
